// ============================================================
// COVER NEAR THE TARGET - the table ruling's choices (2026-10-25).
//
// A solid gives cover only when the cover line leaves it within so many metres of the target's footprint
// edge (`coverReach` in lineOfSight.ts). An enum rather than a number field: the settings registry offers
// toggles and enums, and four distances plus "anywhere" are every answer a table has asked for.
//
// Pure. Zero React dependency.
// ============================================================

export type CoverNearTarget = 'off' | '1' | '2' | '3' | '4';

interface CoverNearTargetEntry {
  key: CoverNearTarget;
  label: string;
  hint: string;
}

/** The rulings on offer, in the order the GM sees them. */
export const COVER_NEAR_TARGET_CHOICES: CoverNearTargetEntry[] = [
  {
    key: 'off',
    label: 'Anywhere on the line',
    hint: "The old rule: terrain anywhere between the two counts, even at the shooter's own feet.",
  },
  { key: '1', label: 'Within 1 m of the target', hint: 'Only what he is pressed right up against.' },
  {
    key: '2',
    label: 'Within 2 m of the target',
    hint: "What he is behind. A berm at the shooter's feet still blocks sight but covers nobody far away.",
  },
  { key: '3', label: 'Within 3 m of the target', hint: 'A little more generous.' },
  { key: '4', label: 'Within 4 m of the target', hint: 'Generous: cover a short dash away still counts.' },
];

const KEYS = new Set(COVER_NEAR_TARGET_CHOICES.map((c) => c.key));

/** The default: 2 m, chosen by the user knowing existing maps change. */
export const DEFAULT_COVER_NEAR_TARGET: CoverNearTarget = '2';

/** A stored ruling is untrusted input - a later build may have written a choice this one lacks. */
export function isCoverNearTarget(value: unknown): value is CoverNearTarget {
  return typeof value === 'string' && KEYS.has(value as CoverNearTarget);
}

/** The reach in metres the cover line uses, or null for "anywhere on the line". */
export function coverReachMetres(choice: CoverNearTarget): number | null {
  return choice === 'off' ? null : Number(choice);
}
